export const TOUR_RECOMMENDED_SUCCESS = "TOUR_RECOMMENDED_SUCCESS";
export const TOUR_RECOMMENDED_ERROR = "TOUR_RECOMMENDED_ERROR";
export const TOUR_RECOMMENDED_START = "TOUR_RECOMMENDED_START";